module.exports = __webpack_public_path__ + "img/986e4dd04f282c78248a3974a3e039d8.743fcb1d.png";